import { render, staticRenderFns } from "./LegalTermsDialog.vue?vue&type=template&id=ea0dad1a&scoped=true&"
import script from "./LegalTermsDialog.vue?vue&type=script&lang=js&"
export * from "./LegalTermsDialog.vue?vue&type=script&lang=js&"
import style0 from "./LegalTermsDialog.vue?vue&type=style&index=0&id=ea0dad1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0dad1a",
  null
  
)

export default component.exports